import { useContext, createContext } from "react";

export const GridContext = createContext();

export const useGrid = ( ) => useContext(GridContext);